// extracted by mini-css-extract-plugin
export default {"container":"slider_container__EuekF","box":"slider_box__bbfZp","leftIcon":"slider_leftIcon__pImRG","rightIcon":"slider_rightIcon__ZXjXK"};